var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3136",
    "data-name": "Rectangle 3136",
    width: 15.161,
    height: 9.749,
    fill: "#444"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9679",
    "data-name": "Group 9679",
    transform: "translate(-746 -371.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(746 371.5)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9252",
    "data-name": "Group 9252",
    transform: "translate(759 386.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9251",
    "data-name": "Group 9251",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M7.63.006A7.823,7.823,0,0,1,9.24.14,8.007,8.007,0,0,1,11,.679a8.246,8.246,0,0,1,3.888,3.534c.073.13.137.265.205.4a.572.572,0,0,1,0,.544l-.047.09A8.642,8.642,0,0,1,14,6.84a8.2,8.2,0,0,1-2.269,1.88,8.073,8.073,0,0,1-1.206.552,8.4,8.4,0,0,1-1.139.318,6.517,6.517,0,0,1-1.139.151c-.386.011-.773.009-1.159,0A6.813,6.813,0,0,1,6.394,9.7c-.235-.028-.467-.076-.7-.12a7.089,7.089,0,0,1-1.35-.432A8.224,8.224,0,0,1,2.512,8.124,7.609,7.609,0,0,1,.9,6.508,10.478,10.478,0,0,1,.1,5.223a.706.706,0,0,1-.006-.705,8.343,8.343,0,0,1,1.9-2.466A7.93,7.93,0,0,1,4.179.673,8.725,8.725,0,0,1,6.032.127,7.243,7.243,0,0,1,7.63.006M7.457,8.689c.287-.015.574-.034.862-.042a5.139,5.139,0,0,0,.771-.1,6.885,6.885,0,0,0,1.446-.464A6.991,6.991,0,0,0,12.492,6.83,6.9,6.9,0,0,0,13.7,5.4c.1-.15.183-.3.274-.457.019-.031.037-.063.015-.1-.1-.169-.182-.345-.29-.506A8.092,8.092,0,0,0,12.472,2.91a6.2,6.2,0,0,0-.906-.693,6.742,6.742,0,0,0-1.17-.6,7.292,7.292,0,0,0-1.687-.449,8.687,8.687,0,0,0-1.088-.079c-.178,0-.355.011-.533.014a5.723,5.723,0,0,0-.882.1,6.818,6.818,0,0,0-1.42.4,7.548,7.548,0,0,0-.993.489,6.67,6.67,0,0,0-1.066.776c-.168.151-.331.307-.491.465-.084.083-.158.177-.235.266a7.489,7.489,0,0,0-.62.835c-.079.123-.143.256-.217.382a.117.117,0,0,0,0,.133,7.444,7.444,0,0,0,.976,1.368,7.318,7.318,0,0,0,1.07.97,7.336,7.336,0,0,0,1.131.677,6.95,6.95,0,0,0,1.4.5,8.444,8.444,0,0,0,1.718.222",
    transform: "translate(0 0)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M113.242,50.916a2.106,2.106,0,0,1-.063.662,2.8,2.8,0,0,1-.726,1.288,2.709,2.709,0,0,1-1.43.734,2.738,2.738,0,0,1-.758.011,2.635,2.635,0,0,1-1.829-1.025,2.544,2.544,0,0,1-.526-1.167,2.481,2.481,0,0,1-.051-.512,2.57,2.57,0,0,1,.119-.74,2.664,2.664,0,0,1,2.053-1.87,3.385,3.385,0,0,1,.477-.064,1.606,1.606,0,0,1,.269.015,2.821,2.821,0,0,1,1.6.688,2.428,2.428,0,0,1,.686,1,2.8,2.8,0,0,1,.182.7,2.374,2.374,0,0,1,0,.279m-1.052.032a1.63,1.63,0,1,0-1.609,1.612,1.624,1.624,0,0,0,1.609-1.612",
    transform: "translate(-102.986 -46.052)",
    fill: "#444"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogEyeIcon);
export default __webpack_public_path__ + "static/media/logEyeIcon.3f62ebd524e063f140f545fbb44b3cd3.svg";
export { ForwardRef as ReactComponent };